import React, { Component, useState, useEffect } from 'react';
import './Form.css';
import { useTranslation } from 'react-i18next';
import './TrainingHVR.css';
import DatePicker from 'react-datepicker';
import '@fortawesome/fontawesome-free/css/all.min.css';


const TrainingHVR = () => {

    useEffect(() => {
        document.title = "HVR Training Rakan Grab";
        const apiEndpoint = '/form/hvrTimeslot';

        const fetchTimeslots = async () => {
            try {
                const response = await fetch(apiEndpoint);
                const data = await response.json();
                setTimeslots(data);
            } catch (error) {
                console.error('Error fetching timeslots:', error);
            }
        };

        fetchTimeslots();
        fetchDriverTimeslot();

    }, []);


    const fetchDriverTimeslot = async () => {
        setIsRegistered(false);
        try {
            // Replace with your actual endpoint URL
            const endpoint = '/form/hvrDriverTimeslot';

            const response = await fetch(endpoint, {
                method: 'GET',
            });
            if (response.status === 404) {
                setIsRegistered(false);
                setSelectedTime(''); // or any default value you prefer
            } else {
                const data = await response.json();
                setSelectedTime(data.time);
                setIsRegistered(true);
            }
        }
        catch {
            setIsRegistered(false);
            setSelectedTime('');
        }
    };

    const [isRegistered, setIsRegistered] = useState(false);
    const [submitDisable, setSubmitDisable] = useState(false);
    const [selectedTime, setSelectedTime] = useState('');
    const [timeslots, setTimeslots] = useState([]);
    const { i18n } = useTranslation();

    const handleTimeChange = (event) => {
        setSelectedTime(event.target.value);
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        setSubmitDisable(true);
        if (!selectedTime) {
            alert('Please select a timeslot before submitting.');
            setSubmitDisable(false);
            return;
        }


        // Replace with your API endpoint for form submission
        const submitEndpoint = `form/newHvrTraining?datetime=${encodeURIComponent(selectedTime)}`;

        fetch(submitEndpoint, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then((response) => {
                    // Handle other errors
                setSubmitDisable(false);
                    return response.text().then((text) => {
                        alert(text);
                    });

                setSubmitDisable(false);
                return response.json();
            });
    };

    return (
        <body>
            <div class="container ">
                <h2 >Compulsory Premium | Exec Service Update Class</h2>
            <h3>Welcome to the GrabExec Training Program!</h3>
            <p>You are required to attend our Premium | Exec service type update class to continue receiving Premium | Exec bookings. This training program is designed to equip you with the skills and knowledge needed to deliver exceptional service for Premium | Exec rides.</p>
            <h3>From this training, you will receive:</h3>
            <ul>
                <li>Updates on Premium | Exec service type requirements</li>
                <li>Goodie bags exclusive to Premium | Exec driver-partners</li>
            </ul>
            <p><strong>Slots are available on a first come, first served basis. Register for your slot now!</strong></p>
            <h3 class="note">PLEASE TAKE NOTE:</h3>
            <ul>
                <li>Arrive at least 15 minutes before the session to ensure smooth registration.</li>
                <li>Latecomers will <strong>NOT</strong> be entertained as this will be disruptive to the session.</li>
                <li>Bring IC (original copy) for verification.</li>
                <li><strong>DATE CHANGE IS NOT ALLOWED</strong> once the slot reservation has been confirmed.</li>
            </ul>
            <div class="venue">
                <h3>Session Venue:</h3>
                <p><strong>GRAB DRIVER CENTRE AXIS</strong> <br/>
                    LEVEL 2, Block A, Axis Business Campus,
                        No 13A & 13B Jalan 225, Section 51A,
                            Petaling Jaya 46100 Selangor.</p>
            </div>
             <p>We look forward to seeing you soon. Thank you!</p>
            </div>
            <form onSubmit={handleSubmit}>
            <div class="timeslot">
                <label className="label-submission">Timeslot</label>
                    <select
                        name="timeslot"
                        id="timeslot"
                        value={selectedTime}
                        onChange={handleTimeChange}
                        disabled={isRegistered} // Disable if a timeslot is registered
                    >
                        <option value="" disabled>Select a time</option>
                        {timeslots.map((slot) => (
                            <option key={slot.timeslot} value={slot.timeslot}>
                                {slot.name}
                            </option>
                        ))}
                    </select>
                
                </div>
                {!isRegistered && (
                    <button type="submit" className="submit-button" disabled={submitDisable}>
                        Book Your Slot
                    </button>
                )}
                {isRegistered && (
                    <button className="submit-button" disabled={true}>
                        Registered
                    </button>
                )}
            </form>
        </body>
    );
}



export default TrainingHVR;
